import styled from "react-emotion";

const PageTitle = styled.h1`
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  font-family: 'Sonsie One', cursive;
  @media (min-width: 768px) {
    & {
      font-size: 41px;
    }
  }
`

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/common/PageTitle.js